/**
 * Reusable skeleton primitives. Use these instead of "Loading…" text
 * for a more polished, perceived-instant loading experience.
 */
export function SkeletonBlock({ className = "", testid }) {
  return (
    <div
      className={`bg-[#e4e4e7] animate-pulse ${className}`}
      data-testid={testid}
    />
  );
}

export function SkeletonText({ width = "w-3/4" }) {
  return <div className={`h-3 bg-[#e4e4e7] animate-pulse ${width}`} />;
}

export function SkeletonStatCard() {
  return (
    <div className="bg-white p-6 flex items-start justify-between">
      <div className="flex-1 space-y-3">
        <SkeletonText width="w-32" />
        <div className="h-10 w-24 bg-[#e4e4e7] animate-pulse" />
      </div>
      <div className="w-7 h-7 bg-[#e4e4e7] animate-pulse rounded" />
    </div>
  );
}

export function SkeletonPurchaseCard() {
  return (
    <div className="border border-[#e4e4e7] bg-white p-5">
      <div className="flex gap-4">
        <div className="w-16 h-16 bg-[#e4e4e7] animate-pulse flex-shrink-0" />
        <div className="flex-1 space-y-2.5 pt-1">
          <SkeletonText width="w-20" />
          <SkeletonText width="w-5/6" />
          <SkeletonText width="w-16" />
        </div>
      </div>
      <div className="mt-5 grid grid-cols-2 gap-3 border-t border-[#e4e4e7] pt-4">
        <div className="space-y-2"><SkeletonText width="w-12" /><div className="h-4 w-16 bg-[#e4e4e7] animate-pulse" /></div>
        <div className="space-y-2"><SkeletonText width="w-12" /><div className="h-4 w-16 bg-[#e4e4e7] animate-pulse" /></div>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <div className="h-5 w-24 bg-[#e4e4e7] animate-pulse" />
        <div className="h-3 w-16 bg-[#e4e4e7] animate-pulse" />
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonPurchaseCard key={i} />
      ))}
    </div>
  );
}
